import React from "react";
import {
  Nfc,
  SignalHigh,
  Receipt,
  TrendingUp,
  RefreshCw,
  ArrowLeftRight,
  SlidersHorizontal,
  ShieldAlert,
} from "lucide-react";
import { services } from "../mock";

const iconMap = {
  Nfc,
  SignalHigh,
  Receipt,
  TrendingUp,
  RefreshCw,
  ArrowLeftRight,
  SlidersHorizontal,
  ShieldAlert,
};

const ServiceCard = ({ item }) => {
  const Icon = iconMap[item.icon];
  if (item.image) {
    return (
      <div className="reveal group relative overflow-hidden rounded-3xl min-h-[320px] flex flex-col justify-end p-8 shadow-[0_20px_60px_-30px_rgba(19,26,51,0.5)]">
        <img
          src={item.image}
          alt={item.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#14102e] via-[#14102e]/70 to-[#14102e]/10" />
        <div className="relative">
          <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#7c3aed] text-white mb-5">
            <Icon className="w-6 h-6" strokeWidth={2.2} />
          </span>
          <h3 className="font-display text-2xl font-semibold text-white">{item.title}</h3>
          <p className="mt-3 text-white/75 leading-relaxed text-[15px]">{item.desc}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="reveal group rounded-3xl bg-white border border-[#1e183a]/8 p-8 min-h-[320px] flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-30px_rgba(19,26,51,0.4)]">
      <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#f4f2fb] text-[#1e183a] mb-5 transition-colors group-hover:bg-[#7c3aed] group-hover:text-white">
        <Icon className="w-6 h-6" strokeWidth={2.2} />
      </span>
      <h3 className="font-display text-2xl font-semibold text-[#1e183a]">{item.title}</h3>
      <p className="mt-3 text-[#1e183a]/65 leading-relaxed text-[15px]">{item.desc}</p>
    </div>
  );
};

const Services = () => {
  return (
    <section id="services" className="bg-[#f4f2fb] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <p className="reveal text-xs font-semibold tracking-[0.22em] uppercase text-[#7c3aed] mb-4">
          What We Help With
        </p>
        <h2 className="reveal font-display text-4xl lg:text-5xl font-semibold text-[#1e183a] leading-tight max-w-2xl">
          Every mobile &amp; SIM headache, handled.
        </h2>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {services.map((s) => (
            <ServiceCard key={s.title} item={s} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
